"use client";

import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Icons } from "@/components/icons";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <html>
      <body>
        <main className="flex min-h-screen flex-col items-center justify-center bg-background p-6">
          <Card className="mx-auto w-full max-w-md p-6">
            <div className="flex flex-col items-center gap-4 text-center">
              <Icons.Warning className="h-12 w-12 text-destructive" />
              <div className="space-y-2">
                <h3 className="text-lg font-semibold sm:text-xl">
                  Critical Error
                </h3>
                <p className="text-sm text-muted-foreground sm:text-base">
                  {error.message ||
                    "A critical error occurred. Please try refreshing the page."}
                </p>
              </div>
              <div className="flex gap-4">
                <Button onClick={reset} variant="default" className="gap-2">
                  <Icons.Refresh className="h-4 w-4" />
                  Try again
                </Button>
                <Button
                  onClick={() => window.location.reload()}
                  variant="outline"
                >
                  Refresh page
                </Button>
              </div>
            </div>
          </Card>
        </main>
      </body>
    </html>
  );
}
